import React from "react";
import { useCart, useCartDispatch } from "../context/CartContext";
import { Link, useNavigate } from "react-router-dom";

const Cart = () => {
  const { cartItems, totalPrice } = useCart();
  const { removeFromCart } = useCartDispatch();
  const navigate = useNavigate();

  if (cartItems.length === 0)
    return (
      <div className="text-center p-10">
        <h2 className="text-xl mb-4">Your cart is empty 🛒</h2>
        <Link
          to="/products"
          className="text-blue-600 hover:underline"
        >
          Browse Products
        </Link>
      </div>
    );

  return (
    <div className="p-10">
      <h1 className="text-2xl font-bold mb-6">Your Cart</h1>
      <div className="space-y-4">
        {cartItems.map((item) => (
          <div
            key={item._id}
            className="flex items-center justify-between p-4 border rounded-lg"
          >
            <div>
              <h3 className="font-semibold">{item.name}</h3>
              <p>₹{item.price} x {item.qty}</p>
            </div>
            <button
              className="text-red-600 font-medium"
              onClick={() => removeFromCart(item._id)}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
      <div className="flex justify-between items-center mt-8 text-lg font-semibold">
        <span>Total:</span>
        <span>₹{totalPrice}</span>
      </div>
      <button
        onClick={() => navigate("/checkout")}
        className="mt-6 bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700"
      >
        Proceed to Checkout
      </button>
    </div>
  );
};

export default Cart;
